import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getServices } from '../services';

/** Quantos mails da caixa de entrada olhar para contar os não lidos (o máximo que o servidor devolve por página). */
const UNREAD_SCAN = 200;

/**
 * O contador de mails não lidos do ícone do correio. A janela do correio atualiza o número a cada ação; o Salão pergunta ao servidor ao abrir e de tempos em tempos.
 * Falha de rede não apaga o número: o contador só deixa de mudar.
 */
export const useMail = defineStore('mail', () => {
  const unread = ref(0);

  async function refresh(): Promise<void> {
    try {
      const { data } = await getServices().api.character.GET('/v1/characters/me/mails', { params: { query: { box: 'inbox', take: UNREAD_SCAN } } });
      if (data) unread.value = data.filter((m) => !m.isRead).length;
    } catch {
      // sem rede ou sem sessão: mantém o número que já havia
    }
  }

  function setUnread(count: number): void {
    unread.value = Math.max(0, count);
  }

  function clear(): void {
    unread.value = 0;
  }

  return { unread, refresh, setUnread, clear };
});
